import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "countryCode" })
export class CountryCodePipe implements PipeTransform {
  transform(value: number) {
    switch (value) {
      case 67:
        return "CA";
      case 85:
        return "US";
      default:
        return "Unknown";
    }
  }
}
